import { useContext } from 'react';
import { GlowContext, type GlowContextValue } from './glow-context-def';

/** Reads the Glow state owned by `GlowProvider` (mounted once in `AppShell`) —
 * shared by the header pill, the Radar page, and anywhere else that needs to
 * know "am I visible right now". */
export function useGlow(): GlowContextValue {
  const ctx = useContext(GlowContext);
  if (!ctx) throw new Error('useGlow must be used within GlowProvider');
  return ctx;
}
